import { render, staticRenderFns } from "./AgencyDirectorySettingsIcon.vue?vue&type=template&id=3cab0763&scoped=true"
import script from "./AgencyDirectorySettingsIcon.vue?vue&type=script&lang=js"
export * from "./AgencyDirectorySettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cab0763",
  null
  
)

export default component.exports